module.exports = __webpack_public_path__ + "static/media/FTML.48d48726.svg";